import ServerSettings from "../../gd/settings/server-settings/server-settings";

const fieldsConfig = {

    'theme': {
        type            : 'option',
        defaultValue    : 'light',
        options         : ['light','dark','auto']
    },
    'fontSize': {
        type            : 'option',
        defaultValue    : 'default',
        options         : ['default','small']
    },

    'lightPalette': {
        type            : 'option',
        defaultValue    : 'light-1',
        options         : ['light-1','light-2','light-3','light-4','light-5']
    },

    'darkPalette': {
        type            : 'option',
        defaultValue    : 'dark-1',
        options         : ['dark-1']
    },

    'layout': {
        type            : 'option',
        defaultValue    : 'left-nav',
        options         : ['left-nav','top-nav']
    },

    'menu': {
        type            : 'option',
        defaultValue    : 'white',
        options         : ['white','gray','dark']
    },

    'navigation': {
        type            : 'option',
        defaultValue    : 'blue',
        options         : ['blue','violet','green','turquoise','dark','gray']
    },

}

export default class UserSettingsSkin extends ServerSettings {

    public theme: any
    public lightPalette: any
    public darkPalette: any
    public fontSize: any
    public layout: any
    public menu: any
    public navigation: any

    constructor(config: any) {

        super(config, fieldsConfig);

        // reserved fo future - specifies which dark mode user has
        this.theme           = this.initValue('theme')

        // current contrast for light palette
        this.lightPalette       = this.initValue('lightPalette')

        // current contrast for dark palette
        this.darkPalette        = this.initValue('darkPalette')

        // font size
        this.fontSize           = this.initValue('fontSize')

        // layout
        this.layout             = this.initValue('layout')

        // menu bg color
        this.menu               = this.initValue('menu')

        // navigation panel color
        this.navigation         = this.initValue('navigation')

        // in future accent color should be here... etc.

    }

    toJson() {

        const result = {};

        this.valueToJson(result, 'theme')
        this.valueToJson(result, 'lightPalette')
        this.valueToJson(result, 'darkPalette')
        this.valueToJson(result, 'fontSize')
        this.valueToJson(result, 'layout')
        this.valueToJson(result, 'menu')
        this.valueToJson(result, 'navigation')

        return result;
    }
}
